/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { dataTablesRequest } from '../models/dataTablesRequest';
import type { merk } from '../models/merk';
import type { vw_merk } from '../models/vw_merk';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MerkService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get datatables
     * @returns any Get datatables successfully
     * @throws ApiError
     */
    public postMerkDataTables({
        requestBody,
    }: {
        requestBody: dataTablesRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/merk/dataTables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Retrieve a list of merks
     * @returns vw_merk A list of merk
     * @throws ApiError
     */
    public getMerk(): CancelablePromise<Array<vw_merk>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/merk',
        });
    }

    /**
     * Create a new Merk
     * @returns any Merk created successfully
     * @throws ApiError
     */
    public postMerk({
        requestBody,
    }: {
        requestBody: merk,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/merk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update an existing Merk
     * @returns any Merk updated successfully
     * @throws ApiError
     */
    public putMerk({
        requestBody,
    }: {
        requestBody: merk,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/merk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Merk not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get merk by id
     * @returns vw_merk The merk data
     * @throws ApiError
     */
    public getMerk1({
        id,
    }: {
        id: string,
    }): CancelablePromise<vw_merk> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/merk/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Merk not found`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete a merk by id
     * @returns any Merk deleted successfully
     * @throws ApiError
     */
    public deleteMerk({
        id,
    }: {
        /**
         * The merk id
         */
        id: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/merk/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Merk not found`,
                500: `Internal server error`,
            },
        });
    }

}
